<template>
  <div class="donut-chart-container">
    <div class="chart-wrapper" :style="chartWrapperStyle">
      <div ref="chart" class="chart" :style="chartStyle"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'DanutChart',
  props: {
    percentage: {
      type: Number,
      required: false,
      default: 0,
      validator: function (value) {
        return value >= 0 && value <= 100
      }
    },
    size: {
      type: Number,
      required: false,
      default: 200
    },
    activeColor: {
      type: String,
      required: false,
      default: '#0CB1F7'
    },
    inactiveColor: {
      type: String,
      required: false,
      default: '#E8E8E8'
    },
    showPercentage: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  computed: {
    chartWrapperStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    },
    chartStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    percentage: {
      handler() {
        this.updateChart()
      },
      deep: true
    },
    size() {
      this.$nextTick(() => {
        if (this.chart) {
          this.chart.resize()
        }
      })
    },
    activeColor() {
      this.updateChart()
    },
    inactiveColor() {
      this.updateChart()
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart)
      this.updateChart()
    },
    updateChart() {
      if (!this.chart) return

      const option = {
        series: [
          {
            type: 'pie',
            radius: ['70%', '90%'], // Mucho más grueso
            center: ['50%', '50%'],
            startAngle: 90,
            data: [
              {
                value: this.percentage,
                name: 'Completado',
                itemStyle: {
                  color: this.activeColor,
                  borderRadius: 50
                }
              },
              {
                value: 100 - this.percentage,
                name: 'Restante',
                itemStyle: {
                  color: this.inactiveColor,
                  borderRadius: 50
                }
              }
            ],
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            emphasis: {
              disabled: true
            },
            animation: true,
            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: 0,
            barWidth: "35%",
          }
        ],
        graphic: this.showPercentage ? [
          {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: `${this.percentage}%`,
              fontSize: 32, // Más pequeño para centro compacto
              fontWeight: 'bold',
              fill: '#2C3E50',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }
          }
        ] : []
      }

      this.chart.setOption(option, true)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.donut-chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-wrapper {
  position: relative;
  border-radius: 20px;
}

.chart {
  width: 100%;
  height: 100%;
}
</style>